// MACHINERY V2 (Stroje) — detail VM -> list-item shape (M2.8).
//
// Spec: data package §11's closing "Catalog-vs-custom" paragraph, which spells
// out how the two view models differ:
//   · `CatalogModelListItemViewModel` carries the flattened Phase-7F NAMES
//     (operationTypeName, axisConfigurationName, controlSystemBrandName,
//     taperTypeName) and the flattened key specs (maxSpindleRpm, spindleHp,
//     spindleDirection, toolCapacity, tableSizeMm);
//   · `CatalogModelDetailViewModel` carries NONE of those, and instead adds the
//     raw operationType / cncModel / numAxesOpt / imagePath / sourceUrl /
//     isActive plus the full specSections.
//
// WHY AN ADAPTER AT ALL. `CatalogAddDialogV2` takes a list item, because the
// browse card is its main caller and because the ONLY fields it actually reads
// are the ones both shapes share: id, modelName, categoryCode, the manufacturer
// summary and the two image URLs. Rather than widen the dialog's prop to a
// union — which would push a `"modelName" in model` test into a component that
// should not care — the detail page converts once, here.
//
// >>> THE ABSENT FIELDS ARE LEFT ABSENT, NOT FAKED. <<<
// Every flattened key spec is `undefined` on the detail VM, so the adapter does
// not invent one. That is correct for the dialog (it renders no key specs) and
// it is why this adapter must NOT be reused to feed a CARD: `CatalogKeySpecs`
// would silently render nothing, and `catalogHasKeySpecs` would report false
// for a model that has plenty of specs — they just live in `specSections` on
// this shape. The detail page renders those through the spec sheet instead.
//
// `readiness` / `isOemPartner` / `oemPartnerName` DO ride on both VMs (the
// backend fills them on the detail DTO in parallel — models.ts's own comment on
// `CatalogModelDetail`), so the readiness kit works identically from either.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import { CatalogModelDetail, CatalogModelListItem } from "../../models/models";

export const detailAsListItem = (model: CatalogModelDetail): CatalogModelListItem => ({
  id: model.id,
  techspexId: model.techspexId,
  modelName: model.modelName,
  categoryCode: model.categoryCode,
  subType: model.subType,
  cncBrand: model.cncBrand,
  numAxes: model.numAxes,
  imageUrl: model.imageUrl,
  imageStandardUrl: model.imageStandardUrl,
  imageDetailUrl: model.imageDetailUrl,
  specsCount: model.specsCount,
  unitsOnPlatform: model.unitsOnPlatform,
  manufacturer: model.manufacturer,
  images: model.images,
  isOemPartner: model.isOemPartner,
  oemPartnerName: model.oemPartnerName,
  readiness: model.readiness,
});
